<div class="page-wrapper">
    <div class="page-content pt-0 pe-2 ps-2">
        <div class="container-fluid">
            <div class="default_class">
                <div class="content-wrapper p-0">

                    <div class="container-fluid">

                        <div class="row">
                            <div class="col-xl-12">
                                <div class="card rounded shadow-lg">
                                    <div class="card-header  headerbg" style="border-bottom:3px solid #d8eff8;">
                                        <h5 class="mb-0">{{headingName.VendorPaymentReports}}</h5>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div *ngIf='isSuperAdmin' class="col-md-3">
                                                <label for="sel1">{{labelName.TenantName}} : </label>
                                                <select [(ngModel)]='tId ' (change)="loadVendors()"
                                                    class="form-control form-control-sm shadow-sm rounded-lg" id="sel1">
                                                    <option value="" [selected]="true">select</option>
                                                    <option *ngFor="let item of tenanates" [value]='item.TNT_CODE'>
                                                        {{item.TNT_NAME}}</option>
                                                </select>

                                            </div>
                                        </div>
                                        <div class="text-right mb-2">
                                            <!-- <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                                data-bs-target="#myModal">Add Vehicle</button> -->
                                        </div>
                                        <div *ngIf="table.length" class="table-responsive">
                                            <table id="patergraph" datatable
                                                class=" table-striped table-bordered mt-2 pt-2 table-sm small display">
                                                <thead class="top" style="background-color: #624FD7; color:#ffffff;">
                                                    <tr>
                                                        <th> Vendor Name</th>
                                                        <th> Phone Number  </th>
                                                        <th> Quotation Number  </th>
                                                        <th> Paid Amount </th>
                                                        <th> Balance Amount </th>
                                                        <th> Payment Mode </th>
                                                        <th> Payment Date </th>
                                                         <th> Cheque Number </th> 
                                                        <th> Cheque Date </th>
                                                        <!-- <th> Tranx No. </th> -->
                                                        <th> Status </th>
                                                    </tr>
                                                </thead>


                                                <tbody>
                                                    <tr *ngFor="let item of table">
                                                        <td>{{item.vendor_name}}</td>
                                                        <td>{{item.phone_number}}</td>
                                                        <td>{{item.quotation_number}}</td>
                                                        <td>{{item.paid_amount}}</td>
                                                        <td>{{item.balance_amount}}</td>
                                                        <td>{{item.payment_mode}}</td>
                                                        <td>{{item.payment_date}}</td>
                                                     <td>{{item.cheque_number !=""?item.cheque_number:"Not an Cheque Number"}}</td> 
                                                        <td>{{item.cheque_date}}</td>
                                                        <!-- <td>{{item.tranx_no}}</td> -->
                                                        <td>{{item.status == true?"Active":"InActive"}}</td>
                                                    </tr>
                                                </tbody>

                                            </table>
                                        </div>


                                        <div class="text-center"*ngIf="!table.length">
                                            No Records to display
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
